module.exports = __webpack_public_path__ + "img/recreates.96ad5d45.jpg";